/**
 * Connector capability flags (enum-compatible const object).
 * Used with erasableSyntaxOnly — behaves as a string enum at runtime.
 */
export const ConnectorCapability = {
  LOGIN: 'LOGIN',
  SEARCH: 'SEARCH',
  PRICE: 'PRICE',
  STOCK: 'STOCK',
  DELIVERY: 'DELIVERY',
  ORDER: 'ORDER',
} as const

export type ConnectorCapability =
  (typeof ConnectorCapability)[keyof typeof ConnectorCapability]

export const ALL_CONNECTOR_CAPABILITIES: ConnectorCapability[] = Object.values(ConnectorCapability)

export function hasCapability(
  capabilities: readonly ConnectorCapability[],
  capability: ConnectorCapability,
): boolean {
  return capabilities.includes(capability)
}
